import { Box } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { useAprovacaoPiloto } from './hooks/useAprovacaoPiloto'
import { CameraView } from './components/CameraView'
import { PhotoPreview } from './components/PhotoPreview'

export function AprovacaoPiloto() {
  const { videoRef, canvasRef, image, preview, loading, canResend, captureImage, approvePilot, setPreview } = useAprovacaoPiloto()

  return (
    <Box bgColor="#313E44" minH="100vh">
      <HeadingPages name={'APROVAÇÃO PILOTO'} bgColor={'#25c07c'} />
      {!preview ? (
        <CameraView videoRef={videoRef} canvasRef={canvasRef} onCaptureImage={captureImage} />
      ) : (
        <PhotoPreview image={image} canResend={canResend} loading={loading} onApprove={approvePilot} onRetake={() => setPreview(false)} />
      )}
    </Box>
  )
}
